const quantityIncreaseElements = document.getElementsByClassName("quantity-input-increase");
const quantityDecreaseElements = document.getElementsByClassName("quantity-input-decrease");

if(quantityIncreaseElements) {
    for(let quantityIncreaseElement of quantityIncreaseElements) {
        quantityIncreaseElement.addEventListener("click",() => increaseInput(quantityIncreaseElement))
    }
}
if(quantityDecreaseElements) {
    for(let quantityDecreaseElement of quantityDecreaseElements) {
        quantityDecreaseElement.addEventListener("click", () => decreaseInput(quantityDecreaseElement))
    }
}

function increaseInput(elem) {
    const inputId = elem.dataset["inputId"];
    const inputElem = document.getElementById(inputId);
    inputElem.value = parseInt(inputElem.value) + 1;
}
function decreaseInput(elem) {
    const inputId = elem.dataset["inputId"];
    const inputElem = document.getElementById(inputId);
    inputElem.value = Math.max(parseInt(inputElem.value) - 1, 1);
}